export default {
  'bindTo': 'this',
  'method': function(){
    alert('Switch-Out')
  },
}
